import React from 'react';
import { FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { products } from '../mock';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../locales/translations';

const Products = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();

  const handleViewDetails = (productSlug) => {
    navigate(`/products/${productSlug}`);
  };

  return (
    <section id="products" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6 leading-[1.15]">
            <span className="bg-gradient-to-r from-orange-600 to-red-600 bg-clip-text text-transparent pb-2">
              {t(language, 'products.title')}
            </span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {language === 'id' ? 'Produk-produk inovatif yang dirancang khusus untuk memenuhi kebutuhan transformasi digital Anda' : 'Innovative products designed specifically to support your digital transformation needs'}
          </p>
        </div>

        {/* Products Grid - single row on desktop (3 columns) */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-7xl mx-auto items-start">
          {products.map((product) => (
            <div key={product.id} className="w-full bg-gradient-to-br from-gray-50 to-white rounded-3xl overflow-hidden shadow-lg border border-gray-100 hover:shadow-2xl transition-all duration-300 group flex flex-col h-full">
              {/* Product Image */}
              <div className="relative h-56 bg-white overflow-hidden flex items-center justify-center p-8 border-b border-gray-100">
                <img
                  src={product.image}
                  alt={product.name}
                  loading="lazy"
                  decoding="async"
                  className="max-w-[75%] max-h-[75%] object-contain transition-transform duration-500 group-hover:scale-110"
                />
              </div>

              {/* Product Content */}
              <div className="p-6 flex flex-col flex-grow">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {product.name}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {typeof product.description === 'object'
                    ? product.description[language] || product.description.id
                    : product.description}
                </p>

                {/* Features List */}
                <ul className="space-y-2 mb-6 flex-grow">
                  {product.features.slice(0, 3).map((feature, idx) => (
                    <li key={idx} className="flex items-start text-sm text-gray-700">
                      <div className="w-1.5 h-1.5 rounded-full bg-orange-500 mt-2 mr-2 flex-shrink-0"></div>
                      <span>{typeof feature === 'object' ? (feature[language] || feature.id) : feature}</span>
                    </li>
                  ))}
                </ul>

                {/* Action Buttons */}
                <div className="flex gap-3 mt-auto">
                  <Button
                    onClick={() => handleViewDetails(product.slug)}
                    className="w-full text-white hover:brightness-110"
                    style={{ background: 'linear-gradient(56deg, rgba(13, 41, 67, 1) 0%, rgba(25, 54, 112, 1) 100%)' }}
                  >
                    {language === 'id' ? 'Lihat Detail' : 'View Details'}
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;


